
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { GameInterface } from "src/app/interfaces/lobby.interface";
import { UserSessionService } from "../user-session/user-session.service";
import { WebservicesService } from "../webservices/webservices.service";
import { API_LIB } from "src/library/api.lib";

@Injectable({ providedIn: 'root' })
export class FavoritesService {

    private favoritesSubject = new BehaviorSubject<GameInterface[]>([]);
    public favorites$ = this.favoritesSubject.asObservable();

    constructor(private webService: WebservicesService,
        private userService: UserSessionService) { }


    /** Initialize favorites (e.g. on app startup or when user logs in) */
    loadInitialFavorites(allCategories: any): void {
        const favCategory = allCategories.find(c => c.action_type === "favorite");
        this.favoritesSubject.next(favCategory?.games || []);
    }

    addToFavorites(gameId: number): Observable<GameInterface[]> {
        return this.webService.post(API_LIB.LOBBY_FAVOURITE_ADD, {
            launch_id: gameId,
            customer_id: this.userService?.customer?.customerId,
            session_token: this.userService?.sessionToken,
        }).pipe(
            tap((updatedFavoritesRespone) => {
                this.favoritesSubject.next(updatedFavoritesRespone.payload);
            })
        );
    }


    removeFavourites(gameId: number): Observable<GameInterface[]> {
        return this.webService.post(API_LIB.LOBBY_FAVOURITE_REMOVE, {
            launch_id: gameId,
            customer_id: this.userService.customer.customerId,
            session_token: this.userService.sessionToken,
        }).pipe(
            tap((updatedFavoritesRespone) => {
                this.favoritesSubject.next(updatedFavoritesRespone.payload);
            })
        );
    }

    isFavorite(gameId): boolean {
        return this.favoritesSubject.getValue().some(g => g.id === gameId);
    }

    getFavoritesSnapshot(): GameInterface[] {
        return this.favoritesSubject.getValue();
    }

}
